/* eslint-disable react/no-danger */
import React, { FunctionComponent, useEffect, useRef } from 'react';
import { compile } from 'handlebars';
import { connect } from 'react-redux';
import { WorkspaceState } from '../../../../reducers/workspace';
import { IAppState } from '../../../../common/models/store/IAppState';
import LoaderWrapper from '../../../../components/LoaderWrapper';
import { getCandidateTemplateCodeRoutine, getReferenceTemplateCodeRoutine } from '../../routines';
import { IBindingAction } from '../../../../common/models/callback';
import { iframeStyleTag } from './utils';
import { EmailType } from '../../../../common/enums/EmailType';
import styles from './styles.module.scss';

interface IProps {
  text: string;
  workspace: WorkspaceState;
  type: EmailType;
  candidateTemplate?: HandlebarsTemplateDelegate<{
    candidate: {
      firstName: string;
      code: string;
      formLink: string;
    };
    color: string;
    logo?: string;
    name: string;
    emailText: string;
  }>;
  referenceTemplate?: HandlebarsTemplateDelegate<{
    color: string;
    emailText: string;
    reference: {
      firstName: string;
      surveyLink: string;
      code: string;
    };
}>
  getCandidateTemplateCode: IBindingAction;
  getReferenceTemplateCode: IBindingAction;
}

const EmailPreview: FunctionComponent<IProps> = ({
  type,
  text,
  workspace,
  candidateTemplate,
  referenceTemplate,
  getCandidateTemplateCode,
  getReferenceTemplateCode
}) => {
  const ref = useRef<HTMLIFrameElement>(null);
  const template = type === EmailType.ReferenceRefRequest ? referenceTemplate : candidateTemplate;

  useEffect(() => {
    const { current: iframe } = ref;
    if (!template) {
      if (type === EmailType.ReferenceRefRequest) {
        getReferenceTemplateCode();
      } else {
        getCandidateTemplateCode();
      }
    } else if (iframe && iframe.contentDocument && iframe.contentWindow) {
      const { contentDocument: document } = iframe;
      document.body.innerHTML = template({
        emailText: text,
        candidate: { firstName: '[Candidate name]', code: 'xxxx', formLink: '' },
        color: workspace.settings?.['--primary-600'],
        logo: workspace.logo,
        name: workspace.name,
        reference: {
          firstName: '[Reference name]',
          surveyLink: '',
          code: 'xxxx'
        }
      });
      const style = document.createElement('style');
      style.innerHTML = iframeStyleTag;
      document.head.appendChild(style);
    }
  }, [candidateTemplate, referenceTemplate]);

  return (
    <LoaderWrapper transparent loading={!template}>
      <div className={styles.previewModalBody}>
        <iframe
          title="email-preview"
          name="email-preview"
          sandbox="allow-same-origin"
          className={styles.previewContainer}
          ref={ref}
        />
      </div>
    </LoaderWrapper>
  );
};

const mapStateToProps = ({ workspace, settings: {
  emailTemplates: { candidateTemplateCode, referenceTemplateCode }
} }: IAppState) => ({
  workspace,
  candidateTemplate: candidateTemplateCode ? compile(candidateTemplateCode) : undefined,
  referenceTemplate: referenceTemplateCode ? compile(referenceTemplateCode) : undefined
});

const mapDispatchToProps = ({
  getCandidateTemplateCode: getCandidateTemplateCodeRoutine,
  getReferenceTemplateCode: getReferenceTemplateCodeRoutine
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailPreview);
